<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <div class="mt-6">
        <v-card elevation="6" class="pa-2">
          <div class="pa-4">
            <span style="font-size: 24px">ตารางสรุปยอดการนับสต๊อก</span>
          </div>
          <v-form ref="form_stock" @submit.prevent="save_data">
            <div class="pa-2">
              <v-card-title>
                <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
              </v-card-title>
              <v-data-table :headers="detailHeader" :items="data_list" key="index" :footer-props="footer_Props" :items-per-page.sync="item_page" :search="search" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" mobile-breakpoint="0">
                <template v-slot:item="dataDetail">
                  <tr>
                    <td>
                      <div v-if="dataDetail.item.product_code !== null">{{ dataDetail.item.product_code }}</div>
                      <div v-else>-</div>
                    </td>
                    <td> {{ dataDetail.item.product_name }}</td>
                    <td class="text-center"> {{ format_number(dataDetail.item.quantity) }}</td>
                    <td> {{ dataDetail.item.unit_name }}</td>
                    <td>
                      <div v-if="dataDetail.item.quantity_cal !== 0">{{ format_number(dataDetail.item.quantity_cal) }}</div>
                      <div v-else>-</div>
                    </td>
                    <td class="text-center">
                      <div v-if="dataDetail.item.before_change < 0" style="color: red">{{ format_number(dataDetail.item.before_change) }}</div>
                      <div v-if="dataDetail.item.before_change === 0">0</div>
                      <div v-if="dataDetail.item.before_change > 0" style="color: #86bc3a">{{ format_number(dataDetail.item.before_change) }}</div>
                    </td>
                    <td>
                      <div class="v-input__slot">
                        <v-checkbox color="#86bc3a" v-model="dataDetail.item.check_box_status" @click="checkStatus(dataDetail.item.loop_id)"/>
                      </div>
                    </td>
                    <td v-if="dataDetail.item.check_box_status === false">
                      <div class="mt-3 mr-1">
                        <v-text-field color="#86bc3a" type="number" class="ma-2" :rules="[v => !!v || 'กรุณาอัพเดทสต๊อก']" required label="อัพเดทสต๊อก" @input="numberAndMinus($event)" v-model="dataDetail.item.confirm_count" hide-details="auto" outlined></v-text-field>
                      </div>
                    </td>
                    <td v-else>
                      <div class="mt-3 mr-1">
                        <v-text-field color="#86bc3a" type="number" class="ma-2" label="อัพเดทสต๊อก" @input="numberAndMinus($event)" hide-details="auto" disabled outlined></v-text-field>
                      </div>
                    </td>
                    <td v-if="dataDetail.item.check_box_status === false">
                      <v-btn small height="42" @click="getlot_change(dataDetail.item.product_id, dataDetail.item.product_name, dataDetail.item.count_save_id)" class="grad-success-bg white--text mr-1 mb-1">
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                    </td>
                    <td v-else>
                      <v-btn small height="42" class="grad-grey-bg white--text mr-1 mb-1" disabled>
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                    </td>
                    <td v-if="dataDetail.item.check_box_status === false && dataDetail.item.lot_change !== null">{{ dataDetail.item.lot_change }}</td>
                    <td v-else>-</td>
                  </tr>
                </template>
              </v-data-table>
            </div>
            <div class="pa-3 text-right">
              <v-btn x-large type="submit" class="grad-success-bg white--text ma-2" style="font-size: 20px" :disabled="btn_disabled">บันทึกการนับสต๊อก</v-btn>
            </div>
          </v-form>
          <v-overlay :value="overlay" class="z_index">
            <div class="text-center">
              <v-progress-circular
                  indeterminate
                  size="70"
                  width="7"
                  color="#86bc3a"
              ></v-progress-circular>
              <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
            </div>
          </v-overlay>
        </v-card>
      </div>
      <v-dialog v-model="lot_change_modal" persistent max-width="1000">
        <v-card>
          <div v-if="loading_lots === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
              <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
          </div>
          <div v-else>
            <v-card-title>
              ปรับส่วนต่าง {{ product_name_change }}
            </v-card-title>
            <v-card-title>
              <v-text-field v-model="search_lot" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
            </v-card-title>
            <div class="pa-4">
              <v-data-table :headers="lots_header" :items="lots_list" :search="search_lot" :footer-props="footer_Props">
                <template v-slot:item="dataDetail">
                  <tr>
                    <td>{{ dataDetail.item.lot_no }}</td>
                    <td>{{ format_number(dataDetail.item.quantity) }}</td>
                    <td>{{ dataDetail.item.unit_name }}</td>
                    <td>{{ dataDetail.item.supplier_name }}</td>
                    <td class="pa-3">
                      <div class="ml-3 mt-n1">
                        <v-btn @click="append_item(dataDetail.item.lot_no,dataDetail.item.warehouse_id)" class="white--text grad-success-bg rounded pl-1 pr-1" title="เพิ่ม">
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </div>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn x-large class="white--text grad-warning-bg ma-2 pa-6" width="20%" type="button" @click="lot_change_modal = false">ย้อนกลับ</v-btn>
            </v-card-actions>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";
import Swal from "sweetalert2";
import {formatNumber, onlyForNumber} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  name: "Warehouse_close",
  data() {
    return {
      loading_page: false,
      loading_lots: false,
      btn_disabled: false,
      lot_change_modal: false,
      product_name_change: null,
      count_save_id: null,
      lot_product_id: null,
      search: null,
      search_lot: null,
      warning: null,
      overlay: false,
      sortBy: 'quantity_count',
      sortDesc: false,
      item_page: -1,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      detailHeader: [
        {
          text: 'รหัสสินค้า',
          value: 'product_code',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'product_name',
          fixed: true,
          width: '300px',
        },
        {
          text: 'จำนวนคงคลัง',
          value: 'quantity',
          fixed: true,
          width: '180px',
        },
        {
          text: 'หน่วย',
          value: 'unit_name',
          fixed: true,
          width: '100px',
        },
        {
          text: 'นับได้',
          value: 'quantity_cal',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ส่วนต่างก่อนปรับ',
          value: 'quantity_count',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ไม่ปรับสต๊อก',
          value: '',
          sortable: false,
          fixed: true,
          width: '150px',
        },
        {
          text: 'ส่วนต่างหลังปรับ',
          value: '',
          fixed: true,
          width: '250px',
        },
        {
          text: 'ปรับสต๊อก',
          value: '',
          sortable: false,
          fixed: true,
          width: '150px',
        },
        {
          text: 'ล็อต',
          value: '',
          fixed: true,
          width: '100px',
        },
      ],
      loop_id: 1,
      data_list: [],
      lots_header: [
        {
          text: 'ล็อต',
          value: 'lot_no',
          fixed: true,
          width: '150px',
        },
        {
          text: 'จำนวน',
          value: 'quantity',
          fixed: true,
          width: '150px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit_name',
          fixed: true,
          width: '200px',
        },
        {
          text: 'ซัพพลายเออร์',
          value: 'supplier_name',
          fixed: true,
          width: '250px',
        },
        {
          text: '',
          value: '',
          sortable: false,
          fixed: true,
          width: '150px',
        },

      ],
      lots_list: [],
    }
  },
  methods: {
    isOnlyNumber: function(evt) {
      return onlyForNumber(evt)
    },
    format_number: function (value) {
      return formatNumber(value)
    },
    numberAndMinus(evt){
      evt = (evt) ? evt : window.event;
      let charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 45)) {
          evt.preventDefault();
      }
      else {
        return true
      }
    },
    get_stock_detail() {
      this.loading_page = true
      let count_stock_id = this.$route.params.id
      HTTP.post('/inventory/counts/getproductinstock', {
        stock_id: count_stock_id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          res.data.object.forEach((data) => {
            this.data_list.push({
              loop_id: this.loop_id,
              count_save_id: data.count_save_id,
              user_count_id: data.user_id,
              lot_no: data.lot_no,
              stock_id: count_stock_id,
              product_id: data.product_id,
              product_code: data.product_code,
              product_barcode: data.product_barcode,
              product_name: data.product_name,
              unit_id: data.unit_id,
              unit_name: data.unit_name,
              unit_qty: data.unit_qty,
              quantity: data.quantity,
              user_id: data.user_id,
              quantity_cal: data.quantity_cal,
              before_change: data.before_change,
              confirm_count: null,
              lot_change: null,
              warehouse_id: null,
              check_box_status: data.check_box_status,
            })
            this.loop_id += 1
          })
        }
      })
    },
    checkStatus(loop_id){
      let value = this.data_list.find((detail) => {
        return loop_id == detail.loop_id
      })
      value.lot_change = null
      value.confirm_count = null
    },
    save_data() {
      if (this.$refs.form_stock.validate()) {
        let check_status_stock = false
        for (let index = 0; index < this.data_list.length; index++) {
          if (this.data_list[index].check_box_status === false && this.data_list[index].lot_change == null) {
            check_status_stock = true
          }
        }
        if (check_status_stock == true) {
             Swal.fire({
              text: 'กรุณาปรับสต๊อก หากไม่ติ้กไม่ปรับสต๊อก',
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            })
        }else{
          this.overlay = true
          this.btn_disabled = true
          let count_stock_id = this.$route.params.id
          HTTP.post('/inventory/counts/stocksave', {
            stock_id: count_stock_id,
            user_confirm_id: this.$store.state.userDetail.id,
            user_confirm_name: this.$store.state.userDetail.name,
            data_list: this.data_list
          }).then((res) => {
            if (res.data.success === true) {
              this.overlay = false
              Swal.fire({
                title: 'บันทึกข้อมูลเรียบร้อย',
                icon: 'success',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              }).then((res) => {
                if (res.isConfirmed) {
                  this.btn_disabled = false
                  this.$router.push('/stock/count_warehouse/countlistwarehouse')
                }
                else {
                  this.btn_disabled = false
                  this.$router.push('/stock/count_warehouse/countlistwarehouse')
                }
              });
            }
          })
        }
      }
    },
    getlot_change(product_id, product_name, count_save_id) {
      this.product_name_change = product_name
      this.lot_change_modal = true
      this.loading_lots = true
      HTTP.post('/inventory/counts/getlotsbyproductid', {
        product_id: product_id,
        count_save_id: count_save_id,
        count_warehouse_id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_lots = false
          this.lots_list = res.data.object.lots_lists
          this.count_save_id = res.data.object.count_save_id
          this.lot_product_id = product_id
        }
      })
    },
    append_item(lot_no,warehouse_id) {
      let result = this.data_list.find((detail) => {
        return detail.product_id == this.lot_product_id
      })
      result.lot_change = lot_no
      result.warehouse_id = warehouse_id
      this.lot_product_id = null
      this.lot_change_modal = false
    }
  },
  beforeMount() {
    this.get_stock_detail();
  }
}
</script>

<style scoped>
.v-input__slot {
  align-items: center !important;
  justify-content: center !important;
  padding-top: 10px !important;
}
</style>
